module.exports = __webpack_public_path__ + "img/Number-of-Reviews-of-Top-100-Restaurants.67c6d342.jpg";